import React from 'react'
import PropTypes from 'prop-types'
import injectSheet from 'react-jss'
import { withTranslation } from 'react-i18next'
import Dropzone from 'react-dropzone'

const styles = () => {
  return {
    container: {
      height: '100%',
      outline: 0,
    },
    overlayStyle: {
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      padding: '2.5em 0',
      background: 'rgba(0,0,0,0.5)',
      textAlign: 'center',
      color: 'white',
    },
    uploadText: {
      border: '1px dotted #D2D2D2',
      height: '100%',
      backgroundColor: 'white',
      width: '100%',
      outline: 0,
      fontSize: '2rem',
      textAlign: 'center',
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
    },
    image: {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
    },
  }
}

const dropzoneRef = React.createRef()
@withTranslation()
@injectSheet(styles)
class ImageDropzone extends React.Component {
  static defaultProps = {
    multiple: false,
  }

  constructor() {
    super()
    this.state = {
      accept: '.jpg,.png,.jpeg',
      dropzoneActive: false,
      images: [],
    }
  }

  handleDragEnter = () => {
    this.setState({
      dropzoneActive: true,
    })
  }

  handleDragLeave = () => {
    this.setState({
      dropzoneActive: false,
    })
  }

  handleDropAccepted = (newFiles) => {
    const { images } = this.state
    const { onDrop, multiple } = this.props
    this.setState({
      dropzoneActive: false,
    })
    if (onDrop) {
      onDrop(newFiles)
    }
    newFiles.forEach((newFile) => {
      Object.assign(newFile, { url: URL.createObjectURL(newFile) })
    })
    if (multiple) {
      this.setState({
        images: [...images, ...newFiles],
      })
    } else {
      images.forEach((image) => {
        URL.revokeObjectURL(image.url)
      })
      this.setState({
        images: [...newFiles],
      })
    }
  }

  handleDropRejected = () => {
    const { onDropRejected } = this.props
    this.setState({
      dropzoneActive: false,
    })
    if (onDropRejected) {
      onDropRejected()
    }
  }

  render() {
    const { accept, dropzoneActive, images } = this.state
    const {
      classes, children, disabled, t,
    } = this.props

    return (
      <Dropzone
        ref={dropzoneRef}
        accept={accept}
        onDropAccepted={this.handleDropAccepted}
        onDropRejected={this.handleDropRejected}
        onDragEnter={this.handleDragEnter}
        onDragLeave={this.handleDragLeave}
        disableClick
        {...this.props}
      >
        {({ getRootProps, getInputProps }) => {
          return (
            <div {...getRootProps()} className={classes.container}>
              {dropzoneActive && !disabled && (
                <div className={classes.overlayStyle}>Drop files...</div>
              )}
              <input {...getInputProps()} />
              {images.map((image, index) => {
                return <img className={classes.image} src={image.url} key={index} alt="" />
              })}
              {images.length === 0 && <div className={classes.uploadText}>{t('select_image')}</div>}
              {children}
            </div>
          )
        }}
      </Dropzone>
    )
  }
}

ImageDropzone.propTypes = {
  classes: PropTypes.object,
  onDrop: PropTypes.func,
  onDropRejected: PropTypes.func,
  // files: PropTypes.arrayOf(PropTypes.object).isRequired,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  multiple: PropTypes.bool,
  t: PropTypes.func,
}

export default ImageDropzone
